module.exports = __webpack_public_path__ + "img/language.b4238f52.svg";